import {HttpModelConverter} from "../../../core/converter/httpModel.converter";
import {MarketingChannelCountByChannelTypeModel} from "../entity/marketingChannelCountByChannelType.model";
import {LovValueSummaryConverter} from "../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {MarketingChannelSummaryModel} from "../../../../shared/model/marketing.channel/marketingChannelSummary.model";
import {PartnerSummaryConverter} from "../../../partner/common/api/converter/partnerSummary.converter";
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class MarketingChannelSummaryConverter extends HttpModelConverter<MarketingChannelSummaryModel>{

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private partnerSummaryConverter: PartnerSummaryConverter) {
        super();
    }

    protected enrichObject(result: MarketingChannelSummaryModel, src: MarketingChannelSummaryModel) {
        result.type = this.lovValueSummaryConverter.convert(src.type);
        result.channelPartnerType = this.lovValueSummaryConverter.convert(src.channelPartnerType);
        result.channelPartner = this.partnerSummaryConverter.convert(src.channelPartner);
        result.partner = this.partnerSummaryConverter.convert(src.partner);
    }

    protected createInstance(): MarketingChannelSummaryModel {
        return new MarketingChannelSummaryModel();
    }


}